$(function () {

      // Slideshow 4
      $("#slider4").responsiveSlides({
        auto: true,
        pager: false,
        nav: true,
        speed: 500,
        namespace: "callbacks",
        before: function () {
          $('.events').append("<li>before event fired.</li>");
        },
        after: function () {
          $('.events').append("<li>after event fired.</li>");
        }
      });

    });


      $(window).on('load',function(){
    var delayMs = 1500; // delay in milliseconds
    
    setTimeout(function(){
        $('#myModal').modal('show');
    }, delayMs);
});

  $(document).ready(function() {  
    var cookieValueannoun = $.cookie("annoucement-new");
    if (cookieValueannoun == 'remove') {
      $('.over-modal').remove();
      $('.modal-backdrop').remove();
      $("body").removeClass("modal-open");
       $("body").css("padding-right", "0px");
    }
     $('.btn-in-msg').click(function(){
       
   $.cookie('annoucement-new', 'remove', { path: '/', expires: 720 / 1440 });
     // localStorage.setItem("annoucement-new","remove");
        $('.over-modal').remove();
       $('.modal-backdrop').remove();
       $("body").removeClass("modal-open");
       $("body").css("padding-right", "0px");
        $(".subscribe-modal").fadeIn(200);
    })
    });
